// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking .heading_first {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 600;
    line-height: 32.78px;
    text-align: left;
    color: #000;

    .heading_second {
        font-family: Manrope;
        font-size: 24px;
        font-weight: 700;
        line-height: 32.78px;
        text-align: left;
        color: #1b9075;
    }
}

.booking .booking_topbar {
    width: auto;
    height: 69px;
    gap: 0px;
    border-radius: 5px;
    background: #ffffff;
    border: 1px solid #e7e7e7;
}

.booking .booking_topbar .head_link {
    font-family: Manrope;
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #000000;
}

.booking .booking_topbar .activeHead {
    display: flex;
    align-items: center;
    width: auto;
    /* width: 179px; */
    height: 41px;
    border-radius: 21px;
    border: 1px solid #e9f4f1;
    background: #1b9075;
    color: #fff;
    box-shadow: 0px 2px 24px 0px #0000002e;

    span {
        padding: 1rem;
    }
}



.booking .ongoing_booking .head_details {
    .heading1 {
        /* width: 206px; */
        /* height: 42px; */
        width: auto;
        height: auto;
        border-radius: 21px;
        background: #1B9075;
        box-shadow: 0px 2px 12px 0px #0000001A;
        font-family: Lexend;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: #FFFFFF;
        padding: 0.5rem 1rem;
    }

    .otp_section {
        font-family: Manrope;
        font-size: 20px;
        font-weight: 700;
        line-height: 27.32px;
        text-align: left;
        color: #FF594C;

    }
}

.booking .ongoing_booking .body {
    border-radius: 5px 5px 0px 0px;
    border: 1px;
    background: #FFFFFF;
    border: 1px solid #E7E7E7;
    .first_section {

        .first_text {
            font-family: Manrope;
            font-size: 16px;
            font-weight: 600;
            line-height: 16px;
            text-align: left;
            color: #13171B;

        }

        .second_text {
            font-family: Manrope;
            font-size: 18px;
            font-weight: 600;
            line-height: 22px;
            text-align: left;
            color: #000000;

        }

        .round_dot {
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #1B9075;
            border-radius: 50%;
            margin: 0 1rem;
        }

        .sub_text {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            text-align: left;
            color: #000000;
        }

        .view_button_more_less {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 500;
            line-height: 22.4px;
            text-align: center;
            color: #1B9075;
        }
    }
    .details_button {
        .hide {
            font-family: Manrope;
            font-size: 18px;
            font-weight: 700;
            line-height: 14px;
            text-align: left;
            color: #38385E;
        }

        .view {
            font-family: Manrope;
            font-size: 18px;
            font-weight: 700;
            line-height: 14px;
            text-align: left;

            color: #1b9075;

        }
    }
}

.booking .ongoing_booking .body .details_section .card_section {
    /* width: 542px; */
    /* height: 82px; */
    /* top: 392px; */
    /* left: 170px; */
    width: auto;
    height: auto;
    border-radius: 4px;
    border: 1px;
    border: 1px solid #CBCBCB;
    background: #FFFFFF;

    .sub_head {
        font-family: Manrope;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: #38385E;

    }

    .sub_text {
        font-family: Manrope;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        color: #38385E;

    }
}

.booking .ongoing_booking .body .workder_details {
    .heading {
        width: auto;
        height: auto;


        font-family: Manrope;
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        text-align: left;
        color: #000000;

    }

    .agent_details {
        width: auto;
        height: auto;

        /* width: 1095px;
        height: 82px;
        top: 639px;
        left: 172px; */
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #EDEDED;

        .name_head {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            text-align: left;
            color: #38385E;

        }

        .agent_name {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 700;
            line-height: 24px;
            text-align: left;
            color: #38385E;

        }

        .agent_rating {
            /* width: 119px; */
            /* height: 37px; */
            width: auto;
            height: auto;
            border-radius: 18.5px;
            border: 1px solid #1B9075;
            padding: 0.5rem;

            .text {
                font-family: Manrope;
                font-size: 14px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;
                color: #1B9075;

            }
        }

        .agentcall_btn {
            /* width: 140px; */
            /* height: 42px;
            top: 659px;
            left: 1107px;
            gap: 0px; */
            border-radius: 9px;
            width: auto;
            height: auto;
            background: #1B9075;
            padding: 0.5rem 1rem;

            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;

        }
    }
}

.booking .ongoing_booking .agent_status {
    /* width: 1138px; */
    /* height: 77px; */
    border-radius: 0px 0px 5px 5px;
    border: 1px solid #DCF3ee;
    background: #DCF3EE;

    .text {
        font-family: Manrope;
        font-size: 16px;
        font-weight: 600;
        line-height: 14px;
        text-align: left;
        color: #1B9075;

    }
}

.booking .ongoing_booking .cancel_button {
    /* width: 179px; */
    /* height: 42px; */
    width: auto;
    height: auto;
    padding: 0.5rem 1rem;
    border-radius: 9px;
    border: 1px solid #1B9075;
    font-family: Manrope;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #1B9075;
}


/* css for modal */

.booking .modal_dialog .modal_content .modal_header {
    width: auto;
    /* height: 48px; */
    height: auto;
    background: #1B9075;

    .head {
        font-family: Lexend;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: #ffffff;
    }

    .close_button {
        background-color: #ffffff;
        border-radius: 50%;
        padding: 0.25rem 0.75rem;
        color: #1B9075;
    }
}

.booking .modal_dialog .modal_content .modal_body {
    .textarea {
        /* width: 312px;
        height: 129px;
        top: 194px;
        left: 564px;
        gap: 0px; */
        border-radius: 5px;
        background: #FFFFFF;
        border: 1px solid #1B9075;
    }
}

.booking .modal_dialog .modal_content .modal_footer {
    button {
        border-radius: 9px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;
        color: #fff;
        background: #1B9075;

    }
}

.booking_card .card_heading {
    .head {
        font-family: Manrope;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        text-align: left;
        color: #202D34;

    }

    .sub_head {
        .first {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: #202D34;

        }

        .second {
            font-family: Manrope;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: #1B9075;

        }
    }
}

.booking_card .card_body .label {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #38385E;

}

.booking_card .card_body .sub_text {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #38385E;

}

.booking_card .buttons {
    .card_view {
        /* width: 147.57px; */
        /* height: 42px; */
        width: 100%;
        height: auto;
        border-radius: 9px;
        background: #E4EFEC;
        color: #1B9075;
        padding: 1rem;

        font-family: Poppins;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;

    }

    .card_book {
        /* width: 147.57px; */
        /* height: 42px; */
        width: 100%;
        height: auto;
        border-radius: 9px;
        background: #1B9075;
        color: #fff;
        padding: 1rem;

        font-family: Poppins;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;

    }
}


.modal_dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.75);
}

.modal_content {
    width: 100%;
    max-width: 24rem;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal_header,
.modal_footer {
    flex-shrink: 0;
}

.modal_body {
    overflow-y: auto;
    flex-grow: 1;
    padding: 1rem;
    background-color: white;
}

/* .modal_btn {
    cursor: pointer;
} */


.round_dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #1B9075;
    border-radius: 50%;
    margin: 0 1rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/postlogin/booking.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;;IAEX;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,sCAAsC;;IAEtC;QACI,aAAa;IACjB;AACJ;;;;AAIA;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,mBAAmB;QACnB,sCAAsC;QACtC,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,cAAc;;IAElB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IAIzB;;QAEI;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,qBAAqB;YACrB,UAAU;YACV,WAAW;YACX,mBAAmB;YACnB,kBAAkB;YAClB,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,kBAAkB;YAClB,cAAc;QAClB;IACJ;IAIA;QACI;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;;YAEhB,cAAc;;QAElB;IACJ;AA3EJ;;AA8EA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;;IAEnB;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;IAElB;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;IAElB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;;;QAGZ,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;IAElB;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ;;;sBAGc;QACd,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;;QAEzB;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,kBAAkB;YAClB,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,qBAAqB;YACrB,yBAAyB;YACzB,eAAe;;YAEf;gBACI,oBAAoB;gBACpB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;;YAElB;QACJ;;QAEA;YACI,kBAAkB;YAClB;;;uBAGW;YACX,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,oBAAoB;;YAEpB,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;;IAEnB;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;IAElB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA,kBAAkB;;AAElB;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;;IAEnB;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,wBAAwB;QACxB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI;;;;mBAIW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;;IAEvB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;IAElB;;IAEA;QACI;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;;QAElB;;QAEA;YACI,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;;QAElB;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI;QACI,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,aAAa;;QAEb,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;;IAEtB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,aAAa;;QAEb,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;;IAEtB;AACJ;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;GAEG;;;AAGH;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".booking .heading_first {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32.78px;\n    text-align: left;\n    color: #000;\n\n    .heading_second {\n        font-family: Manrope;\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 32.78px;\n        text-align: left;\n        color: #1b9075;\n    }\n}\n\n.booking .booking_topbar {\n    width: auto;\n    height: 69px;\n    gap: 0px;\n    border-radius: 5px;\n    background: #ffffff;\n    border: 1px solid #e7e7e7;\n}\n\n.booking .booking_topbar .head_link {\n    font-family: Manrope;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    color: #000000;\n}\n\n.booking .booking_topbar .activeHead {\n    display: flex;\n    align-items: center;\n    width: auto;\n    /* width: 179px; */\n    height: 41px;\n    border-radius: 21px;\n    border: 1px solid #e9f4f1;\n    background: #1b9075;\n    color: #fff;\n    box-shadow: 0px 2px 24px 0px #0000002e;\n\n    span {\n        padding: 1rem;\n    }\n}\n\n\n\n.booking .ongoing_booking .head_details {\n    .heading1 {\n        /* width: 206px; */\n        /* height: 42px; */\n        width: auto;\n        height: auto;\n        border-radius: 21px;\n        background: #1B9075;\n        box-shadow: 0px 2px 12px 0px #0000001A;\n        font-family: Lexend;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n        color: #FFFFFF;\n        padding: 0.5rem 1rem;\n    }\n\n    .otp_section {\n        font-family: Manrope;\n        font-size: 20px;\n        font-weight: 700;\n        line-height: 27.32px;\n        text-align: left;\n        color: #FF594C;\n\n    }\n}\n\n.booking .ongoing_booking .body {\n    border-radius: 5px 5px 0px 0px;\n    border: 1px;\n    background: #FFFFFF;\n    border: 1px solid #E7E7E7;\n}\n\n.booking .ongoing_booking .body {\n    .first_section {\n\n        .first_text {\n            font-family: Manrope;\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 16px;\n            text-align: left;\n            color: #13171B;\n\n        }\n\n        .second_text {\n            font-family: Manrope;\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 22px;\n            text-align: left;\n            color: #000000;\n\n        }\n\n        .round_dot {\n            display: inline-block;\n            width: 5px;\n            height: 5px;\n            background: #1B9075;\n            border-radius: 50%;\n            margin: 0 1rem;\n        }\n\n        .sub_text {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 22px;\n            text-align: left;\n            color: #000000;\n        }\n\n        .view_button_more_less {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 22.4px;\n            text-align: center;\n            color: #1B9075;\n        }\n    }\n}\n\n.booking .ongoing_booking .body {\n    .details_button {\n        .hide {\n            font-family: Manrope;\n            font-size: 18px;\n            font-weight: 700;\n            line-height: 14px;\n            text-align: left;\n            color: #38385E;\n        }\n\n        .view {\n            font-family: Manrope;\n            font-size: 18px;\n            font-weight: 700;\n            line-height: 14px;\n            text-align: left;\n\n            color: #1b9075;\n\n        }\n    }\n}\n\n.booking .ongoing_booking .body .details_section .card_section {\n    /* width: 542px; */\n    /* height: 82px; */\n    /* top: 392px; */\n    /* left: 170px; */\n    width: auto;\n    height: auto;\n    border-radius: 4px;\n    border: 1px;\n    border: 1px solid #CBCBCB;\n    background: #FFFFFF;\n\n    .sub_head {\n        font-family: Manrope;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n        color: #38385E;\n\n    }\n\n    .sub_text {\n        font-family: Manrope;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 24px;\n        text-align: left;\n        color: #38385E;\n\n    }\n}\n\n.booking .ongoing_booking .body .workder_details {\n    .heading {\n        width: auto;\n        height: auto;\n\n\n        font-family: Manrope;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: left;\n        color: #000000;\n\n    }\n\n    .agent_details {\n        width: auto;\n        height: auto;\n\n        /* width: 1095px;\n        height: 82px;\n        top: 639px;\n        left: 172px; */\n        border-radius: 4px;\n        background: #FFFFFF;\n        border: 1px solid #EDEDED;\n\n        .name_head {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 24px;\n            text-align: left;\n            color: #38385E;\n\n        }\n\n        .agent_name {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 700;\n            line-height: 24px;\n            text-align: left;\n            color: #38385E;\n\n        }\n\n        .agent_rating {\n            /* width: 119px; */\n            /* height: 37px; */\n            width: auto;\n            height: auto;\n            border-radius: 18.5px;\n            border: 1px solid #1B9075;\n            padding: 0.5rem;\n\n            .text {\n                font-family: Manrope;\n                font-size: 14px;\n                font-weight: 600;\n                line-height: 24px;\n                text-align: left;\n                color: #1B9075;\n\n            }\n        }\n\n        .agentcall_btn {\n            /* width: 140px; */\n            /* height: 42px;\n            top: 659px;\n            left: 1107px;\n            gap: 0px; */\n            border-radius: 9px;\n            width: auto;\n            height: auto;\n            background: #1B9075;\n            padding: 0.5rem 1rem;\n\n            font-family: Poppins;\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 24px;\n            text-align: left;\n            color: #FFFFFF;\n\n        }\n    }\n}\n\n.booking .ongoing_booking .agent_status {\n    /* width: 1138px; */\n    /* height: 77px; */\n    border-radius: 0px 0px 5px 5px;\n    border: 1px solid #DCF3ee;\n    background: #DCF3EE;\n\n    .text {\n        font-family: Manrope;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 14px;\n        text-align: left;\n        color: #1B9075;\n\n    }\n}\n\n.booking .ongoing_booking .cancel_button {\n    /* width: 179px; */\n    /* height: 42px; */\n    width: auto;\n    height: auto;\n    padding: 0.5rem 1rem;\n    border-radius: 9px;\n    border: 1px solid #1B9075;\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #1B9075;\n}\n\n\n/* css for modal */\n\n.booking .modal_dialog .modal_content .modal_header {\n    width: auto;\n    /* height: 48px; */\n    height: auto;\n    background: #1B9075;\n\n    .head {\n        font-family: Lexend;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n        color: #ffffff;\n    }\n\n    .close_button {\n        background-color: #ffffff;\n        border-radius: 50%;\n        padding: 0.25rem 0.75rem;\n        color: #1B9075;\n    }\n}\n\n.booking .modal_dialog .modal_content .modal_body {\n    .textarea {\n        /* width: 312px;\n        height: 129px;\n        top: 194px;\n        left: 564px;\n        gap: 0px; */\n        border-radius: 5px;\n        background: #FFFFFF;\n        border: 1px solid #1B9075;\n    }\n}\n\n.booking .modal_dialog .modal_content .modal_footer {\n    button {\n        border-radius: 9px;\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: center;\n        color: #fff;\n        background: #1B9075;\n\n    }\n}\n\n.booking_card .card_heading {\n    .head {\n        font-family: Manrope;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: left;\n        color: #202D34;\n\n    }\n\n    .sub_head {\n        .first {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 24px;\n            color: #202D34;\n\n        }\n\n        .second {\n            font-family: Manrope;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 24px;\n            color: #1B9075;\n\n        }\n    }\n}\n\n.booking_card .card_body .label {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #38385E;\n\n}\n\n.booking_card .card_body .sub_text {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 24px;\n    text-align: left;\n    color: #38385E;\n\n}\n\n.booking_card .buttons {\n    .card_view {\n        /* width: 147.57px; */\n        /* height: 42px; */\n        width: 100%;\n        height: auto;\n        border-radius: 9px;\n        background: #E4EFEC;\n        color: #1B9075;\n        padding: 1rem;\n\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: center;\n\n    }\n\n    .card_book {\n        /* width: 147.57px; */\n        /* height: 42px; */\n        width: 100%;\n        height: auto;\n        border-radius: 9px;\n        background: #1B9075;\n        color: #fff;\n        padding: 1rem;\n\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: center;\n\n    }\n}\n\n\n.modal_dialog {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    background-color: rgba(0, 0, 0, 0.75);\n}\n\n.modal_content {\n    width: 100%;\n    max-width: 24rem;\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.modal_header,\n.modal_footer {\n    flex-shrink: 0;\n}\n\n.modal_body {\n    overflow-y: auto;\n    flex-grow: 1;\n    padding: 1rem;\n    background-color: white;\n}\n\n/* .modal_btn {\n    cursor: pointer;\n} */\n\n\n.round_dot {\n    display: inline-block;\n    width: 5px;\n    height: 5px;\n    background: #1B9075;\n    border-radius: 50%;\n    margin: 0 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
